import { render, staticRenderFns } from "./ProductVariant.vue?vue&type=template&id=6765e830&"
import script from "./ProductVariant.vue?vue&type=script&lang=js&"
export * from "./ProductVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports